import { OwcCard, OwcIcon, OwcTooltip, OwcTypography } from "@one/react";

import { generateID } from "@digitallab/grid-common-components";
import {
  LinkContainerDivInnerLeft,
  LinkContainerDivInnerRight,
  LinkContainerDivView,
  LinkContainerStyled
} from "./log-book-item-form-dialog/FormsStyled";

const ActionLogLinkDetailView = ({ externalDocuments }) =>
  externalDocuments?.length > 0 ? (
    <div style={{ margin: "10px 0" }}>
      <OwcCard
        flat
        style={{
          padding: "0px",
          width: "90%",
          border: "1px solid var(--one-color-interaction-default-neutral-2)"
        }}
      >
        <div
          slot="header"
          style={{
            display: "flex",
            background: "var(--one-color-background-neutral-2)",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "-3px",
            padding: "10px"
          }}
        >
          <OwcTypography
            variant="button"
            id={generateID.UUID("AddLinkHeadingBanner", `addLinkHeadingBanner`, "type_title")}
          >
            <strong>Link list</strong>
          </OwcTypography>
        </div>
        <LinkContainerStyled
          data-testid="link-block"
          id={generateID.UUID("LinkBlock", `link_block`, "div")}
        >
          {externalDocuments?.map((item, index) => {
            return (
              <LinkContainerDivView key={`action-log-link-item-${index}`}> 
                <LinkContainerDivInnerLeft>
                  <OwcIcon type="outlined" name="link"></OwcIcon>
                  <OwcTypography
                    variant="subtitle2"
                    id={generateID.UUID("LinkBlockName", `link_block_name`, `div-${index}`)}
                    style={{
                      marginLeft: "5px",
                      color: "var(--one-color-interaction-default-brand-1)",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      wordWrap: "break-word",
                      width: "415px"
                    }}
                  >
                    {item.name}
                  </OwcTypography>
                  <OwcTooltip anchor={generateID.UUID("LinkBlockName", `link_block_name`, `div-${index}`)} placement='top'>
                    {item.name}
                  </OwcTooltip>
                </LinkContainerDivInnerLeft>
                <LinkContainerDivInnerRight isLinkTable>
                  <div
                    style={{ cursor: "pointer", marginRight: "5px" }}
                    onClick={() => {
                      window.open(`${item.link}`);
                    }}
                  >
                    <OwcIcon
                      name="launch"
                      type="filled"
                      variant="primary"
                      id={generateID.UUID("LinkBlockEdit", `link_block`, `icon-${index}`)}
                    ></OwcIcon>
                    <OwcTooltip anchor={generateID.UUID("LinkBlockEdit", `link_block`, `icon-${index}`)}>
                      {"Link"}
                    </OwcTooltip>
                  </div>
                </LinkContainerDivInnerRight>
              </LinkContainerDivView>
            );
          })}
        </LinkContainerStyled>
      </OwcCard>
    </div>
  ) : (
    <></>
  );

export default ActionLogLinkDetailView;
